









import { defineComponent } from "@vue/composition-api";
import { Transaction } from "@scrile/api-provider/dist/api/TransactionProvider";
import TransactionView from "../TransactionView.vue";

export default defineComponent({
  name: "TransactionTip",
  components: {
    TransactionView,
  },
  props: {
    transaction: { type: Object as () => Transaction, required: true },
  },
});
